export const defaultBase = 'https://www.volvocars.com/static/shared/pkg/';
